import * as types from "./mutation-types";

export const setPayerData = ({ commit }, payload) => {
  commit(types.SET_PAYER_DATA, payload);
};

export const setPayerValidationFields = ({ commit }, payload) => {
  commit(types.SET_PAYER_VALIDATION_FIELDS, payload);
};

export const setDowngradeData = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    try {
      commit(types.SET_DOWNGRADE_DATA, payload);
      resolve("downgradeData saved");
    } catch (err) {
      reject(err);
    }
  });
};
